module.exports = __webpack_public_path__ + "5b98afb96054e0fa36a8299869f7f464.png";